var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchPlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 12,
    fill: "url(#paint0_linear_705_7594)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.3673 37.3224C43.057 32.7691 42.4455 26.8049 38.5327 22.8928C33.9341 18.2935 26.5018 18.2557 21.8557 22.7771C17.171 27.3363 17.1072 35.0335 21.7191 39.6669C25.632 43.5969 31.6073 44.2151 36.1688 41.5209L38.0079 43.36L42.2064 39.1616L40.3673 37.3224Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0029 43.3597L42.2009 39.1618L43.7748 40.7357L39.5768 44.9337L38.0029 43.3597Z",
    fill: "#66BFE9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.246 28.3204C48.4757 28.3204 49.4725 27.3235 49.4725 26.0938C49.4725 24.8641 48.4757 23.8672 47.246 23.8672C46.0163 23.8672 45.0194 24.8641 45.0194 26.0938C45.0194 27.3235 46.0163 28.3204 47.246 28.3204Z",
    fill: "#313A52"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7538 46.133C23.5739 46.133 24.2382 46.7979 24.2382 47.6174C24.2382 48.4374 23.5739 49.1017 22.7538 49.1017C21.9344 49.1017 21.2694 48.4374 21.2694 47.6174C21.2694 46.7979 21.9344 46.133 22.7538 46.133Z",
    fill: "#313A52"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9082 25.5165C39.0967 28.7049 39.0967 33.8743 35.9082 37.0626C32.7206 40.2504 27.5512 40.2504 24.3628 37.0626C21.1743 33.8743 21.1743 28.7049 24.3628 25.5165C27.5513 22.328 32.7206 22.328 35.9082 25.5165Z",
    fill: "#66BFE9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5041 45.4591C49.0837 46.0388 49.3739 46.7986 49.3739 47.5579C49.3739 48.3179 49.0837 49.0779 48.5041 49.6576C47.3447 50.8169 45.4648 50.8169 44.3055 49.6576L39.5822 44.9343L43.7807 40.7357L48.5041 45.4591Z",
    fill: "#335E78"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.919 31.7968C51.0482 32.1857 50.8381 32.6058 50.4492 32.7357C50.0604 32.8648 49.6403 32.6548 49.5104 32.2659C49.3814 31.877 49.5913 31.4569 49.9803 31.327C50.3691 31.1979 50.7892 31.408 50.919 31.7968Z",
    fill: "#66BFE9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2081 36.25C47.3373 36.6389 47.1272 37.0597 46.7383 37.1889C46.3495 37.3188 45.9294 37.1087 45.7995 36.7198C45.6704 36.3309 45.8804 35.9108 46.2693 35.7809C46.6581 35.651 47.0782 35.8611 47.2081 36.25Z",
    fill: "#66BFE9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0127 19.1796C42.1426 19.5685 41.9326 19.9886 41.5438 20.1185C41.1549 20.2476 40.734 20.0376 40.605 19.6487C40.4751 19.2598 40.685 18.8397 41.074 18.7098C41.4628 18.5807 41.8837 18.7908 42.0127 19.1796Z",
    fill: "#66BFE9"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3644 48.125C32.4943 48.5139 32.2835 48.934 31.8946 49.0639C31.5065 49.1938 31.0857 48.983 30.9565 48.5948C30.8266 48.2059 31.0367 47.7851 31.4256 47.6559C31.8145 47.526 32.2346 47.7361 32.3644 48.125Z",
    fill: "#66BFE9"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4894 42.1875C20.6193 42.5764 20.4085 42.9965 20.0196 43.1264C19.6315 43.2563 19.2107 43.0455 19.0815 42.6573C18.9516 42.2684 19.1617 41.8476 19.5506 41.7184C19.9395 41.5885 20.3596 41.7986 20.4894 42.1875Z",
    fill: "#66BFE9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7473 19.9218C19.8771 20.3107 19.6664 20.7308 19.2775 20.8607C18.8893 20.9905 18.4685 20.7798 18.3393 20.3916C18.2094 20.0027 18.4195 19.5819 18.8084 19.4527C19.1973 19.3228 19.6174 19.533 19.7473 19.9218Z",
    fill: "#66BFE9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0529 35.9486C33.8629 35.9486 33.673 35.8761 33.5281 35.7313C33.2382 35.4414 33.2382 34.9714 33.5281 34.6816C35.3987 32.8109 35.3987 29.7673 33.5281 27.8967C33.2382 27.6069 33.2382 27.1369 33.5281 26.847C33.8179 26.5573 34.2878 26.5573 34.5777 26.847C37.027 29.2964 37.027 33.2818 34.5777 35.7312C34.4327 35.8762 34.2428 35.9486 34.0529 35.9486Z",
    fill: "#E0CEB3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9569 51.3283H36.1132C35.7033 51.3283 35.371 50.9959 35.371 50.5861C35.371 50.1762 35.7033 49.8439 36.1132 49.8439H50.9569C51.3667 49.8439 51.6991 50.1762 51.6991 50.5861C51.6991 50.9959 51.3667 51.3283 50.9569 51.3283Z",
    fill: "#EDAD0C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_705_7594",
    x1: 35,
    y1: 0,
    x2: 35,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#0294F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0274BC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchPlaceholder);
export default __webpack_public_path__ + "static/media/search_placeholder.ef5eb230d7cbae329df3017b9d4554bc.svg";
export { ForwardRef as ReactComponent };